import React from "react";
import Addbook from "../components/Addbook/Addbook";

export default function Addpage() {
  return (
    <main className="py-6 2xl:px-6">
      <Addbook />
    </main>
  );
}
